import { Placement } from '@popperjs/core';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';

import Overlay from './Overlay';
import * as styles from './styles.css';
import Box from '../Box';

const POPPER_OFFSET = 6;

interface PopoverProps {
  anchor: HTMLElement;
  onOverlayClick?: (event: React.SyntheticEvent) => void;
  onEscKeyDown?: (event: KeyboardEvent) => void;
  placement?: Placement;
  children?: React.ReactNode;
}

const Popover: React.FC<PopoverProps> = ({
  anchor,
  onEscKeyDown,
  onOverlayClick,
  children,
  placement = 'bottom-end',
}) => {
  const [root] = useState(document.createElement('div'));
  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null);
  const { styles: popperStyles, attributes } = usePopper(anchor, popperElement, {
    placement,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, POPPER_OFFSET],
        },
      },
    ],
  });

  useEffect(() => {
    document.body.appendChild(root);

    return () => {
      document.body.removeChild(root);
    };
  }, [root]);

  const popper = (
    <>
      <Overlay active onClick={onOverlayClick} onEscKeyDown={onEscKeyDown} />
      <Box ref={setPopperElement} style={popperStyles.popper} {...attributes.popper} className={styles['popover']}>
        <Box className={styles['inner']}>{children}</Box>
      </Box>
    </>
  );

  return createPortal(popper, root);
};

export default Popover;
